var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _dec6, _class2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _dec7, _class3, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogMemberTraits from "./CatalogMemberTraits";
import EnumDimensionTraits from "./DimensionTraits";
import GroupTraits from "./GroupTraits";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import UrlTraits from "./UrlTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
export let ReplaceStringTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Find",
  description: "String to find"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Replace",
  description: "String to replace with"
}), _class = class ReplaceStringTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "find", _descriptor, this);
    _initializerDefineProperty(this, "replace", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "find", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "replace", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
/**
 * Notes on region mapping:
 * RegionType is determined by sdmxJsonDataflowStratum.column in this order:
 * - `modelOverrideTraits.regionType`
 * - if `modelOverrideTraits.type === 'region'` and there exists another modelOverrideTraits with `type === 'region-type'` in the datastructure, then region-type will be set from its corresponding dimension
 * - the dimension id
 * - the codelist name
 * - the codelist id (the actual string, not URN form)
 * - the concept name
 * - the concept id (the actual string, not URN form)
 *
 * Then regionTypeReplacements are applied (which can replace regionType with a different regionType - using [{find:string, replace:string}] pattern)
 */
export let ModelOverrideTraits = (_dec3 = primitiveTrait({
  type: "string",
  name: "ID",
  description: "Concept ID (full URN form - urn:sdmx:org.sdmx.infomodel.conceptscheme.Concept=ABS:CS_C16_COMMON(1.0.0).REGION)"
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Type",
  description: "Override concept/dimension type - Possible values are:\n      - 'region': values contain region codes used for region mapping - eg Country code)\n      - 'region-type': values contains region types - eg 'CNT2' which is 2-letter country codes)\n      - 'unit-measure': values should be used to describe primary-measure (eg in chart title)\n      - 'unit-multiplier': multiply primary-measure value by atrtibute values\n      - 'frequency': value used to determine time period frequency (ie. yearly, monthly...)"
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Region type",
  description: "If `type` has been specified as 'region', you can also manually specify the region type (eg SA2 for ABS Statistical Area 2)"
}), _dec6 = objectArrayTrait({
  type: ReplaceStringTraits,
  idProperty: "index",
  name: "Region type",
  description: "If `type` has been specified as 'region' and this dataflow contains multiple regionTypes - you can add a map to correct automatically detected region types. For example: setting `regionTypeReplacements = [{find: 'SA1_2016', replace: 'SA1_2011'}]` will replace `regionType` with `SA1_2011` if it was `SA1_2016`"
}), _class2 = class ModelOverrideTraits extends mixTraits(EnumDimensionTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "id", _descriptor3, this);
    _initializerDefineProperty(this, "type", _descriptor4, this);
    _initializerDefineProperty(this, "regionType", _descriptor5, this);
    _initializerDefineProperty(this, "regionTypeReplacements", _descriptor6, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "id", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "regionType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "regionTypeReplacements", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let SdmxCommonTraits = (_dec7 = objectArrayTrait({
  type: ModelOverrideTraits,
  idProperty: "id",
  name: "Concept overrides",
  description: "This provides ability to override Dataflow dimensions by concept or codelist ID (full URN). For example, setting a default value for a given concept. Codelist overrides take priority over concept overrides. TODO add example"
}), _class3 = class SdmxCommonTraits extends mixTraits(UrlTraits, CatalogMemberTraits, LegendOwnerTraits, GroupTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "modelOverrides", _descriptor7, this);
  }
}, _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "modelOverrides", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export { SdmxCommonTraits as default };